import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import ContentLoading from 'Components/ComponentLibrary/Molecules/ContentLoading';
import { useIncludedRelationshipContext } from 'Views/Page/Contexts/IncludedRelationshipContext';
import Content from './Content';

const Container = () => {
  const {
    isInitializing,
    relationshipRefreshError,
  } = useIncludedRelationshipContext();

  return (
    <DataContainer
      component={Content}
      loading={isInitializing}
      loadingError={relationshipRefreshError}
      skeleton={ContentLoading}
    />
  );
};

export default Container;
